module.exports = __webpack_public_path__ + "media/images/pipedrive-fb8df70b10394561657df851e4a40ac6.svg";